
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-revigres/projects",
      function () {
        return require("private-next-pages/my-revigres/projects/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-revigres/projects"])
      });
    }
  